import { Button } from '@heroui/react';
import { StatCard } from '@/components/molecules/StatCard';
import { useDashboardPage } from './useDashboardPage';
import { PageContainer } from '@/components/templates/PageContainer';

export function DashboardPage() {
  useDashboardPage();

  return (
    <PageContainer>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-foreground">Dashboard</h2>
        <Button size="md">Создать визит</Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Визиты сегодня" value="—" />
        <StatCard label="Ожидают проверки" value="—" status="warning" />
        <StatCard label="Утверждены" value="—" status="success" />
        <StatCard label="Оплачены" value="—" status="accent" />
      </div>
    </PageContainer>
  );
}
